import { useEffect, useState } from "react"
import { getCategories, getImageUrl } from "../api/api"

function TestAPI() {
  const [categories, setCategories] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    getCategories().then((data) => {
      setCategories(data)
      setLoading(false)
    })
  }, [])

  if (loading) return <h2 style={{padding: "20px"}}>Loading Data from Server...</h2>

  return (
    <div style={{ padding: "20px", display: "flex", flexWrap: "wrap", gap: "20px" }}>
      {categories.length > 0 ? (
        categories.map(cat => (
          <div key={cat.id} style={{ border: "1px solid #ddd", padding: "10px", borderRadius: "8px", textAlign: "center" }}>
            <img 
              src={getImageUrl(cat.image)} 
              alt={cat.name} 
              width="150" 
              height="150" 
              style={{ objectFit: "cover", borderRadius: "5px" }} 
            />
            <h3 style={{ fontSize: "16px", marginTop: "10px" }}>{cat.name}</h3>
          </div>
        ))
      ) : (
        <p>No categories found. Check console for errors.</p>
      )}
    </div>
  )
}

export default TestAPI